import type { FunctionComponent, PropsWithChildren } from "react";
const SidebarHeader: FunctionComponent<PropsWithChildren> = ({ children }) => (
	<div className="bg-gray-100 px-7 py-5">{children}</div>
);
export default SidebarHeader;